<div class="vstack gap-3">
    <div class="vstack gap-2">
        <h5 class="fw-semibold m-0 px-3">
            Seating Area
        </h5>
    </div>
    <div class="vstack gap-2">
        @if (!availability.isConfigurationReservable(
            form.get('partySize')?.value,
            form.get('selectedReasonId')?.value,
            form.get('selectedEventId')?.value
        )) {
            <app-no-availability
                [availability]="availability"
                [requiresDogFriendly]="form.get('requiresDogFriendly')?.value"
                [idealTime]="form.get('idealTime')?.value"
                [partySize]="form.get('partySize')?.value"
                [areaId]="form.get('selectedAreaId')?.value"
                [eventId]="form.get('selectedEventId')?.value"
                [reasonId]="form.get('selectedReasonId')?.value"
                (joinWaitlistRequested)="joinWaitlistRequested.emit()"
            >
            </app-no-availability>
        } @else {
            @for (area of availableAreas; track area.area.id) {
                <label
                    class="btn btn-outline-secondary p-2 d-flex flex-column justify-content-center align-items-center"
                    [class.disabled]="!area.areaCanBeBooked || !isAreaReservable(area.area)"
                    data-testid="area-select"
                >
                    <div class="m-1 hstack gap-2">
                        <input
                            type="radio"
                            [value]="area.area.id"
                            [checked]="selectedArea?.id === area.area.id"
                            (change)="onAreaSelected(area.area)"
                            class="form-check-input m-0"
                            role="button"
                        >
                        <div class="vstack align-items-start">
                            <span class="fw-semibold">
                                {{ area.area.displayName }}
                            </span>
                            <span
                                *ngIf="area.area.description"
                                class="small"
                            >
                                {{ area.area.description }}
                            </span>
                            <span
                                *ngIf="!area.areaCanBeBooked || !isAreaReservable(area.area)"
                                class="small"
                            >
                                Unavailable
                            </span>
                        </div>
                    </div>
                </label>
            }
        }
    </div>
    @if (availability.isConfigurationReservable(
        form.get('partySize')?.value,
        form.get('selectedReasonId')?.value,
        form.get('selectedEventId')?.value
    )) {
        <div class="vstack gap-2">
            @if (showValidationError) {
                <div class="text-danger small px-3">
                    Please select a seating area.
                </div>
            }
            <button
                class="btn btn-primary"
                type="button"
                (click)="next()"
                [disabled]="isLoading"
            >
                Next
            </button>
        </div>
    }
</div>
